<template>
  <div id="happiness-guarantee-modal" class="grid-enabled large-modal">
    <div class="close-modal" @click="$root.$emit('closeModal')">
      <img src="@/assets/icons/close.svg" />
    </div>

    <div class="modalHeader header-md mx-auto">
      <img :height="isMobile ? 120 : 160" class="mb-4" :src="content.img" />
      <p class="font-bold header-md px-5" v-html="content.title" />
    </div>
    <div class="modalContent w-100 mx-auto text-center" v-limit="490">
      <p
        class="font-large"
        v-html="isMobile ? content.shortDescription : content.fullDescription"
      />
      <div
        v-limit="280"
        class="font-small mx-auto charcoal-40--txt mt-4 pointer"
        @click="goToTerms"
        v-html="content.footer"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import content from '@/content/promotions/bungalowGuarantee.js'

export default {
  name: 'HappinessGuaranteeModal',
  data() {
    return {
      content,
    }
  },
  mounted() {
    this.$segment.track('Open Modal', {
      CTA: 'Learn More',
      location: 'Banner',
      modal: 'Happiness Guarantee',
    })
  },
  computed: {
    ...mapGetters(['isMobile']),
  },
  methods: {
    goToTerms() {
      this.$root.$emit('closeModal')
      this.$router.push({ path: this.content.path, query: this.$route.query })
    },
  },
}
</script>
<style lang="scss">
#happiness-guarantee-modal {
  .link {
    cursor: pointer;
    color: $blue-80;
    text-decoration: underline;
  }
}
</style>
